// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

// pull in all our icons in one shot
import './icons';

import App from './App';
import './index.css';

const domain   = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

// ─── SETUP DYNAMIC VH ─────────────────────────────────────────
function updateVh() {
  // 1% of the viewport height → --vh
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`
  );
}
// run once on load
updateVh();
// re-run on every resize (including mobile toolbar show/hide)
window.addEventListener('resize', updateVh);
// ────────────────────────────────────────────────────────────────

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience,
        scope: 'openid profile email'
      }}
    >
      <App />
    </Auth0Provider>
  </BrowserRouter>
);
